import { render, staticRenderFns } from "./ItemizedView.vue?vue&type=template&id=597e0db2&scoped=true"
import script from "./ItemizedView.vue?vue&type=script&lang=js"
export * from "./ItemizedView.vue?vue&type=script&lang=js"
import style0 from "./ItemizedView.vue?vue&type=style&index=0&id=597e0db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597e0db2",
  null
  
)

export default component.exports